import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { BusinessUnitsService } from '../business-units.service'; 
import { BusinessUnit } from '../business-unit.model';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-edit-business-unit',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    ToastModule,
    CardModule
  ],
  templateUrl: './edit-business-unit.component.html',
  providers: [MessageService]
})
export class EditBusinessUnitComponent implements OnInit {
  businessUnitId: number | null = null;
  businessUnitForm!: FormGroup;
  isEditMode = false;
  pageTitle = 'Create New Business Unit';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,      
    private businessUnitsService: BusinessUnitsService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.businessUnitId = +id;
        this.isEditMode = true;
        this.pageTitle = 'Edit Business Unit';
        this.loadBusinessUnitData(this.businessUnitId); 
      }
    });
  }

  initForm(): void {
    this.businessUnitForm = this.fb.group({
      businessUnitName: ['', Validators.required],
      businessUnitCode: [''],
      arAccount: [''],
      apAccount: [''],
      reference: [''],
    });
  }

  loadBusinessUnitData(id: number): void {
    this.businessUnitsService.getBusinessUnitById(id).subscribe({
      next: (businessUnit) => this.businessUnitForm.patchValue(businessUnit),
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load business unit data.' });
        console.error(err);
      }
    });
  }

  saveBusinessUnit(): void {
    if (this.businessUnitForm.invalid) {
      this.businessUnitForm.markAllAsTouched(); 
      return;
    }

    const businessUnitData: BusinessUnit = { id: this.businessUnitId ?? 0, ...this.businessUnitForm.value };
    console.log(this.businessUnitForm.value);
    const operation = this.isEditMode
      ? this.businessUnitsService.updateBusinessUnit(businessUnitData)
      : this.businessUnitsService.createBusinessUnit(businessUnitData);

    operation.subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `Business ${this.isEditMode ? 'updated' : 'created'} successfully.` });
        setTimeout(() => this.router.navigate(['/ai-studio/session/current', { outlets: { canvasOutlet: ['businessUnit', 'list'] } }]), 1500);
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to ${this.isEditMode ? 'update' : 'create'} branch.` });
        console.error(err);
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/ai-studio/session/current', { outlets: { canvasOutlet: ['businessUnit', 'list'] } }]);
  }
}
